export default __webpack_public_path__ + "static/media/CTAWHATSAPP.afa1f8e6.png";